export enum QueryOperationTypeEnum {
  Get = 'Get',
  WhereOrHaving = 'WhereOrHaving',
  GroupOrAggregate = 'GroupOrAggregate',
  GroupOrAggregatePlusSort = 'GroupOrAggregatePlusSort',
  Limit = 'Limit',
  Sort = 'Sort',
  Move = 'Move',
  Remove = 'Remove',
  Replace = 'Replace'
}
